import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { RatingsReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const ratingsReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...RatingsReducerHandlers.fetchRatingsByUserId,
    ...RatingsReducerHandlers.addOrUpdateRating,
    ...RatingsReducerHandlers.getUserWithMiscData,
    ...RatingsReducerHandlers.changeRatingStatus,
    ...RatingsReducerHandlers.deleteRating,
    ...RatingsReducerHandlers.getProjectsFeedbackData,
    ...RatingsReducerHandlers.getProjectsFeedbackForExcel,
  },
);

export default ratingsReducer;
